import React, { useState, useEffect } from "react";
import PT from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link, ResponsiveImage } from "@quintype/components";
import { STATIC_KEYWORDS } from "../../../constants";
import { getSectionUrl } from "../../../utils/story-utils";

import "./search-page-card.m.css";

function formatMonthYear(dateString) {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, { month: "short", year: "numeric" });
  } catch (e) {
    return "";
  }
}

export const SearchPageCard = ({ story }) => {
  const section = get(story, ["sections", 0]);
  const isPremium = get(story, ["access"]) === "subscription";
  const publishedOn = formatMonthYear(get(story, ["published-at"])) || formatMonthYear(get(story, ["first-published-at"]));
  const alternativeHeadline = get(story, ["alternative", "home", "default", "headline"]);
  const headline = alternativeHeadline || story.headline;
  const summary = get(story, ["subheadline"]) || get(story, ["summary"]) || "";
  const reportTag = story?.tags?.find(tag => tag.type === "report-type");
  const [svgUrl, setSvgUrl] = useState("");

  useEffect(() => {
    if (reportTag?.id) {
      fetch(`/api/v1/entities/${reportTag.id}`)
        .then(res => res.json())
        .then(data => {
          const url = data?.entity?.["desktop-svg"]?.[0]?.url;
          if (url) setSvgUrl(url);
        })
        .catch(err => console.error("Error fetching entity:", err));
    }
  }, [reportTag?.id]);

  const alternateImageS3Key = get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]);
  const imageS3Key = alternateImageS3Key || story["hero-image-s3-key"];

  const fallbackImage = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "fallback-image"], "")
  );

  return (
    <div styleName="card">
      <div>
        {svgUrl && (
          <img
            styleName="svg-logo"
            src={svgUrl}
            alt={reportTag?.properties?.["desktop-svg"]?.[0]?.caption}
          />
        )}
      </div>
      <Link aria-label="search-card" href={`/${story.slug}`} styleName="image-link">
        <figure className="qt-image-1x1" styleName="thumb">
          {
            imageS3Key ? (
              <ResponsiveImage
                slug={imageS3Key}
                metadata={story["hero-image-metadata"]}
                aspectRatio={[16, 9]}
                defaultWidth={144}
                widths={[96, 144, 192]}
                imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
                alt={headline || ""}
              />
            ) : (
              <img
                src={fallbackImage}
                alt={headline || ""}
              />
            )}
        </figure>
      </Link>

      <div styleName="content">
        <div styleName="top-row">
          {section && (
            <Link styleName="category" href={getSectionUrl(section)}>
              {section.name.toUpperCase()}
            </Link>
          )}
          <Link href={`/${story.slug}`} styleName="headline" aria-label="headline">
            {headline}
          </Link>
          {summary ? <Link href={`/${story.slug}`}><p styleName="summary">{summary}</p></Link> : null}
        </div>

      </div>
      <div styleName="date-wrapper">
        {publishedOn ? <span styleName="date">{publishedOn}</span> : null}
        {isPremium ? <span styleName="premium-tag">{STATIC_KEYWORDS.PREMIUM}</span> : null}
      </div>

    </div>
  );
};

SearchPageCard.propTypes = {
  story: PT.shape({
    id: PT.string,
    slug: PT.string,
    headline: PT.string,
    "hero-image-s3-key": PT.string,
    "hero-image-metadata": PT.object,
  }),
};


